import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import React from 'react';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { Cell, List, Row } from '../../../components/List';
import { selectWork, selectWorks } from '../../Api/selectors';
import { fetchCompanyProductsIds, fetchProducts, productSearch } from '../actions';
import { REQUEST_COMPANY_PRODUCTS_IDS, REQUEST_PRODUCTS, REQUEST_PRODUCT_SEARCH } from '../constants';
import { BaseComponent } from '../../../components/BaseComponent';
import { INVOICE_DIRECTIONS } from '../../Invoices/constants';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { selectProducts } from '../selectors';
import { formatCurrency } from '../../../utils/string';

const STATE = {
  string: '',
};

const Wrap = styled.div`
  width: 100%;
  .basic-multi-select {
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class ProductSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCompanyProductsIds(res => {
      if (res?.length) {
        const options = {};
        if (this.props.companyId) options.companyId = this.props.companyId;
        if (this.props.taxRegion) options.taxRegion = this.props.taxRegion;
        if (this.props.vehiclePurpose) options.vehiclePurpose = this.props.vehiclePurpose;
        this.props.fetchProducts(options, undefined, 5000);
      } else {
        this.props.fetchProducts();
      }
    });
    if (this.props.currentSubject && this.props.currentSubject.id) {
      const product = this.props.currentSubject?.product;
      let price;
      let name;
      if (product) {
        const priceField =
          this.props.invoice?.direction == INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';
        price = product[priceField];
        name = product?.name;
      } else {
        price = this.props.currentSubject?.product_price_excl_vat;
        name = this.props.currentSubject?.description;
      }
      this.setState({
        selectedProduct: this.props.currentSubject,
        string: `${name ?? ''} - ${formatCurrency(price || '0')}`,
      });
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  applySelection(product) {
    this.props.onComplete(product);
    this.reset();
  }

  onStringChange(evt) {
    let string = evt;
    this.setState({ string });
    if (!string) return;
    this._t = this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const search = normalizeSearchString(this.state.string);
    const vehiclePurposeType = normalizeSearchString(this.props.vehicle?.vehicle_purpose);
    this.props.search(search, vehiclePurposeType, result =>
      this.setState({
        result: result.items
          ?.filter(product => product.id != this.state.product?.id)
          ?.filter(product => {
            if (this.props.direction === INVOICE_DIRECTIONS.INCOMING) {
              return product.ledgerIn && product.vatIn;
            }

            if (this.props.direction === INVOICE_DIRECTIONS.OUTGOING) {
              return product.ledgerOut && product.vatOut;
            }

            return false;
          }),
      }),
    );
  }

  render() {
    let products = this.state.string ? this.state.result : this.props.products;
    let noVehicleProducts = products?.filter(product => product?.isCounter != '1');
    const price =
      this.props.invoice?.direction == INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';

    let options = products
      ?.filter(product => product?.status === '0')
      ?.map(product => {
        return {
          product: product,
          value: product?.id,
          label: `${product?.name ?? ''} - ${formatCurrency(product[price] || '0')}`,
        };
      });

    if (!this.props.vehicleId) {
      options = noVehicleProducts
        ?.filter(product => product?.status === '0')
        ?.map(product => {
          return {
            product: product,
            value: product?.id,
            label: `${product?.name ?? ''} - ${formatCurrency(product[price] || '0')}`,
          };
        });
    }
    return (
      <Wrap>
        <SearchSelect
          isLoading={this.props.workProducts}
          options={options}
          inputValue={this.state.string}
          onInputChange={this.onStringChange.bind(this)}
          onChange={e => {
            if (e.value) {
              this.setState({ selectedProduct: e.product });
              this.applySelection(e?.product);
            }
            return;
          }}
        />
      </Wrap>
    );
  }

  renderResult() {
    if (!this.state.result) return '';
    return (
      <div className="results">
        <List>
          {this.state.result.map(product => (
            <Row
              key={product.id}
              onClick={() => {
                this.setState({ result: null, selectedProduct: product, string: product.name });
              }}
            >
              <Cell>{product.name}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

ProductSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    searching: selectWork(REQUEST_PRODUCT_SEARCH),
    workProducts: selectWorks([REQUEST_PRODUCTS, REQUEST_PRODUCT_SEARCH, REQUEST_COMPANY_PRODUCTS_IDS]),
    products: selectProducts(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, vehiclePurposeType, callback) {
      const options = {};
      if (ownProps.companyId) options.companyId = ownProps.companyId;
      if (ownProps.taxRegion) options.taxRegion = ownProps.taxRegion;
      if (ownProps.vehiclePurpose) options.vehiclePurpose = ownProps.vehiclePurpose;
      dispatch(productSearch(string, vehiclePurposeType, options, callback));
    },
    fetchProducts(options = {}, callback, limit) {
      dispatch(fetchProducts(options, callback, 0, limit));
    },
    fetchCompanyProductsIds(callback) {
      dispatch(fetchCompanyProductsIds(ownProps.companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductSelection = compose(withConnect, withRouter, injectIntl)(ProductSelectionComp);
